// extracted by css-extract-rspack-plugin
export default {"container":"_d2e8d0a4","large":"_512d839e","innerContainer":"_1e76fd3a","detailsWrapper":"_8f5f1912","title":"_7434b563"};